import { render, staticRenderFns } from "./ContractRbuSectionFluctuationRow.vue?vue&type=template&id=0a5f5f82"
import script from "./ContractRbuSectionFluctuationRow.vue?vue&type=script&lang=js"
export * from "./ContractRbuSectionFluctuationRow.vue?vue&type=script&lang=js"
import style0 from "./ContractRbuSectionFluctuationRow.vue?vue&type=style&index=0&id=0a5f5f82&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports